export default __webpack_public_path__ + "static/media/Calendar.393f1356.svg";